import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { videoFolderSelectors } from '../../../store/modules/videoFolder';

const useStreamFolderPath = (path = '/', projectId?: string, folderId?: number) => {
  const folderPath = useSelector(state => videoFolderSelectors.getFolderPathFor(state, folderId));

  const [streamPath, setStreamPath] = useState(path);

  useEffect(() => {
    if (path === streamPath) return;

    setStreamPath(path);
  }, [path]);

  useEffect(() => {
    if (!projectId || !folderPath) return;

    setStreamPath(`/${folderPath}`);
  }, [projectId, folderPath]);

  return streamPath;
};

export default useStreamFolderPath;
